import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTurnDefinitionAction } from "../actions";
import { getLoading, getData, getSchedules } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

const TurnDefinition = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);
    const schedules = useSelector(getSchedules);

    useEffect(() => {
        dispatch(getTurnDefinitionAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    return (
        <ABMLayout
            title={getLocalizedString("turnDefinition")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newShift")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noShiftsFound")}
            noDataCreateTitle={getLocalizedString("newShift")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={() => history.push(paths.timeDefinition)}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem schedules={schedules} color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} color={color} schedules={schedules} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default TurnDefinition;
